import { BotDetails } from 'enablex/sdk'
import React, { FC } from 'react'
import CodeSnippetIcon from '~/icons/CodeSnippetIcon'

interface Props {
  botId: string | null
  whiteListedDomains: string[]
  details: BotDetails
  isOpen: boolean
  toggle: () => void
}

interface ModalProps {
    modalProps: Props
}

const WebTab: FC<ModalProps> = props => {
    const { modalProps } = props
    return (
        <>
            {
                modalProps.whiteListedDomains.length ? <p></p> :
                    <p >
                        <span style={{ color: 'red' }}> No Domain whitelisted for this bot. </span>
                        <a href={`studio/${modalProps.botId}/config`} target='_blank'>Click here to configure </a>
                    </p>
            }
            <pre
                id='copy-deploy-code'
                style={{
                    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.15)',
                    borderRadius: '6px',
                    padding: '10px',
                    maxWidth: '800px',
                    overflowX: 'auto'
                }}>
                {
                    `
<script src="${window.EXTERNAL_URL}/assets/modules/channel-web/inject.js"></script>
<script>
    window.enablexWebBot.init({ host: "${window.EXTERNAL_URL}", botId: "${modalProps.botId}", })
    window.addEventListener('message', function(event) {
        let request = event.data;
        if (request.name === 'showEnablexIframe') {
            window.enablexWebBot.addEnablexDiv({ iFrameURL: request.iFrameURL, chatId: request.chatId })
        } else if (request.name === 'hideEnablexIframe')  {
            window.enablexWebBot.removeEnablexDiv({ chatId: request.chatId })
        }
    });
</script>`
                }
            </pre>
        </>)
}

export default WebTab
